export const isVotingSessionOpen = (session) => session.is_open;
